import React from "react";
import { ActionIcon, CopyButton, Tooltip } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { DESIGN_ICONS } from "../../theme/designIcons";

export interface CopyLinkIconProps {
  /** The URL copied to the clipboard; renders nothing when empty. */
  value: string;
  /** Tooltip + accessible name, e.g. "Copy booking link". */
  label: string;
  /** ActionIcon size in px. */
  size?: number;
  className?: string;
}

/**
 * Icon-only "copy link" button: the link icon swaps to a check and the
 * tooltip to "Copied!" for 2s after a click. Used for the calendar header's
 * booking link and the walk-ins drawer / sheet's walk-in link.
 */
export const CopyLinkIcon: React.FC<CopyLinkIconProps> = ({
  value,
  label,
  size = 26,
  className,
}) => {
  if (!value) return null;
  return (
    <CopyButton value={value} timeout={2000}>
      {({ copied, copy }) => (
        <Tooltip label={copied ? "Copied!" : label} withArrow>
          <ActionIcon
            variant="subtle"
            color="gray"
            size={size}
            radius={7}
            className={className}
            onClick={copy}
            aria-label={label}
          >
            {copied ? <IconCheck size={15} /> : <DESIGN_ICONS.Link size={15} />}
          </ActionIcon>
        </Tooltip>
      )}
    </CopyButton>
  );
};

export default CopyLinkIcon;
